import { Chip } from '@mui/material';

export function StatusChip({ status }) {
    const statusConfig = {
        approved: { label: 'Approved', color: 'success' },
        pendingCreate: { label: 'Create pending', color: 'warning' },
        pendingEdit: { label: 'Edit pending', color: 'warning' },
        pendingReport: { label: 'Report pending', color: 'error' },
        rejected: { label: 'Rejected', color: 'error' },
        deleted: { label: 'Deleted', color: 'error' },
        pendingDelete: { label: 'Delete pending', color: 'error' },
        reported: { label: 'Reported', color: 'error' },
    };

    const config = statusConfig[status] || { label: status, color: 'default' };

    return (
        <Chip
            label={config.label}
            color={config.color}
            size="small"
        />
    );
}